import * as R from 'ramda';
// constants
import * as GC from '../constants';
// utilities
import routesMap from '../utilities/routes';
// helpers
import { ifElse, notContain } from './helpers';
//////////////////////////////////////////////////

const History = {
  navigate: null,
  push: (page, ...rest) => (
    History.navigate ? History.navigate(page, ...rest) : undefined
  ),
};

const setHistoryNavigate = (fn) => {
  History.navigate = fn;
};

const goToRoute = async (route, ...rest) => History.push(route, ...rest);

const historyGoBack = () => History.push(-1);

const getWindowLocationPathname = () => window.location.pathname;

const getCurrentPathname = () => R.pathOr(getWindowLocationPathname(), ['location', 'pathname'], History);

const windowLocationReload = () => window.location.reload();

const isEqualCurrentPathnameAndRouteName = (routeName) => R.equals(getCurrentPathname(), routeName);

const isNotOldTelDetails = () => notContain('route/tel', getCurrentPathname());

const getSplittedUrlLocation = (divider) => (
  window.location.host.split(divider)
);

const equalLocationPathname = R.equals(window.location.pathname);

const getLoadRouteByConfigAndLoadType = (routesMap, guid, isClo = false) => ifElse(
  isClo,
  routesMap.dispatchDetailsOrder,
  routesMap.dispatchDetailsLoad,
)(guid);

const goToLoadDetailsByConfigAndLoadType = (routesMap, guid, isClo = false) => {
  const route = getLoadRouteByConfigAndLoadType(routesMap, guid, isClo);

  goToRoute(route);
};

const goToCarrierProfile = (guid) => goToRoute(routesMap.carrierProfile(guid));

// pages
const isLoginPage = R.equals(GC.ROUTE_PATH_LOGIN);
const isPageDispatchPlanner = R.equals(GC.PAGE_DISPATCH_PLANNER);
const isPageDispatchBoardNew = R.equals(GC.PAGE_DISPATCH_BOARD_NEW);
const isPageDispatchPlannerEvents = R.equals(GC.PAGE_DISPATCH_PLANNER_EVENTS);
const isPageDispatchDetailsNewLoad = R.equals(GC.PAGE_DISPATCH_DETAILS_NEW_LOAD);
const isPageDispatchDetailsNewOrder = R.equals(GC.PAGE_DISPATCH_DETAILS_NEW_ORDER);

export {
  goToRoute,
  historyGoBack,
  setHistoryNavigate,
  goToCarrierProfile,
  getCurrentPathname,
  isNotOldTelDetails,
  windowLocationReload,
  equalLocationPathname,
  getSplittedUrlLocation,
  getWindowLocationPathname,
  getLoadRouteByConfigAndLoadType,
  goToLoadDetailsByConfigAndLoadType,
  isEqualCurrentPathnameAndRouteName,
  // pages
  isLoginPage,
  isPageDispatchPlanner,
  isPageDispatchBoardNew,
  isPageDispatchPlannerEvents,
  isPageDispatchDetailsNewLoad,
  isPageDispatchDetailsNewOrder,
};

export default History;
